<script setup>
import { ref, onMounted, onUnmounted, computed, defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { initConfigStore, useInfoStore } from '@/stores/counter.js'
import { showToast } from 'vant'
import DesktopHeader from '@/components/web/DesktopHeader.vue'
import DesktopFooter from '@/components/web/DesktopFooter.vue'
import MobileHeader from '@/components/mobile/MobileHeader.vue'
import defaultAvatar from '@/assets/img/web_home/弹窗切图/信息卡上大头像/1.png'
import { ElCarousel, ElCarouselItem } from 'element-plus'
import { shouldUseMobileLayout } from '@/util/mobileMode'

const isMobile = ref(shouldUseMobileLayout())
const handleResize = () => {
  isMobile.value = shouldUseMobileLayout()
}

let showMobileUserMenu = ref(false)

const getVipImage = (level) => {
  level = Number(level) || 0
  return new URL(`../../assets/img/web_home/弹窗切图/VIP${level}@2x.png`, import.meta.url).href
}

onMounted(() => {
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
import encipher from '@/util/mySEC'
import {
  getReqData,
  GetStrategyListAPI,
  GetBannerAPI,
  GetHotWordAPI,
  BehaviorEventAPI,
  GetMenuListAPI,
  GetHomeCategoryAPI,
  GetChangeInfoAPI,
  shareTrendsAPI,
  upLikeTrendsAPI,
  UserRegisterAPI,
  GetUserInfoAPI,
  GetVoucherListNewUserAPI,
  ReceiveGiftNewAPI,
  GetTChuangListAPI,
  CilckADAPI,
  LoginAPI,
  GetBindEmailAPI,
  GetHomeActivityListAPI,
  GetHomeSpecialListAPI,
  GetHomePublicListAPI,
  GetHomeTopTrendsListAPI
} from '@/util/api'
import router from '@/router'

const $route = useRoute()
const $router = useRouter()
const initStore = initConfigStore()
const initInfo = computed(() => {
  return initStore.initConfig
})
const userStore = useInfoStore()
const userInfo = computed(() => {
  return userStore.userInfo
})

const ElementCarousel = defineComponent(ElCarousel)
const ElementCarouselItem = defineComponent(ElCarouselItem)

let strategyListMore = ref('')
let showSearch = ref(false)
let word = ref('')
let initTimeOut = ref(null)
let bannerData = ref('')
let homeActivityData = ref([])
let specialAnnouncementsData = ref([])
let topArticlesData = ref([])
let topTrendsData = ref([])
let hotWordData = ref('')
let showMenu = ref(false)
let menuList = ref('')
let isTips = ref(false)
let categoryList = ref('')
let homeTrendsData = ref('')
let shareData = ref('')
let showAttention = ref(false)
let clickPoll = ref(null)
let timeCount = ref(3)
let isPoll = ref(false)
let transfer = ref('')
let showBackTips = ref(false)
let showGiftPack = ref(false)
let showRegister = ref(false)
let userUname = ref('')
let userUpwd = ref('')
let showVoucher = ref(false)
let voucherList = ref('')
let showDonwn = ref(true)
let adList = ref('')

const getBanner = () => {
  let reqData = JSON.parse(localStorage.getItem('href-url'))
  GetBannerAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        bannerData.value = res.data.data
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}
const getStrategyList = () => {
  let reqData = JSON.parse(localStorage.getItem('href-url'))
  if (word.value) {
    reqData.word = word.value
  } else {
    reqData.word = ''
  }
  GetStrategyListAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        // if (word.value) {
        strategyListMore.value = res.data.data
        word.value = ''
        showSearch.value = false
        // } else {
        //   strategyList.value = res.data.data[0]
        //   strategyListMore.value = res.data.data.slice(1, strategyList.length)
        //   word.value = ''
        //   showSearch.value = false
        // }
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}
const getHotWord = () => {
  let reqData = JSON.parse(localStorage.getItem('href-url'))
  GetHotWordAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        hotWordData.value = res.data.data
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}
const handelHot = (hot) => {
  word.value = hot.name
  getStrategyList()
  behaviorEvent({ event: 'search_hotword', module: 'walkthrough' }, hot)
}
const behaviorEvent = (event, data) => {
  let reqData = {
    uid: userInfo.value.uid || '',
    uname: userInfo.value.uname || '',
    token: userInfo.value.token || '',
    link_id: data.id,
    track_id: '',
    url: window.location.href
  }
  reqData = Object.assign(JSON.parse(localStorage.getItem('href-url')), reqData, event)
  BehaviorEventAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        console.log(res.data.msg)
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}
const handelMenu = () => {
  showMenu.value = !showMenu.value
}
const getMenu = () => {
  if (menuList.value) {
    return
  }
  let reqData = {
    uid: userInfo.value.uid || '',
    uname: userInfo.value.uname || '',
    token: userInfo.value.token || ''
  }
  reqData = Object.assign(JSON.parse(localStorage.getItem('href-url')), reqData)
  GetMenuListAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        showMenu.value = false
        transfer.value = res.data.data.circle
        menuList.value = res.data.data.list
        if (menuList.value.length > 0) {
          menuList.value.forEach((element) => {
            if (element.is_red) {
              isTips.value = true
            }
          })
        }
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}
const getHomeCategory = () => {
  let reqData = {
    uid: userInfo.value.uid || '',
    uname: userInfo.value.uname || '',
    token: userInfo.value.token || ''
  }
  reqData = Object.assign(JSON.parse(localStorage.getItem('href-url')), reqData)
  GetHomeCategoryAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        console.log('【首页分类接口返回】', res)
        categoryList.value = res.data.data
        categoryList.value.forEach((cate) => {
          cate.checked = 0
        })
        categoryList.value[0].checked = 1
        getChangeInfo(categoryList.value[0])
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}
const handelCategory = (cate) => {
  console.log('【选择分类】', cate)
  categoryList.value.forEach((ele) => {
    ele.checked = 0
  })
  cate.checked = 1
  if (cate.doway == '10') {
    $router.push(cate.path)
  }
  if (cate.doway == '11') {
    getChangeInfo(cate)
  }
}
const getChangeInfo = (cate) => {
  const urlObj = cate.path.split('?')[1] ? cate.path.split('?')[1] : ''
  let reqData = JSON.parse(localStorage.getItem('href-url'))
  if (word.value) {
    reqData.word = word.value
  } else {
    reqData.word = ''
  }
  if (urlObj) {
    reqData = Object.assign(reqData, Object.fromEntries(new URLSearchParams(urlObj).entries()))
  }
  reqData.uid = userInfo.value.uid || ''
  reqData.uname = userInfo.value.uname || ''
  reqData.token = userInfo.value.token || ''
  GetChangeInfoAPI(cate.path.split('?')[0], getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        console.log('【首页分类接口返回】', res)
        if (res.data.data.stype == 1) {
          strategyListMore.value = res.data.data
          homeTrendsData.value = ''
        }
        if (res.data.data.stype == 2) {
          homeTrendsData.value = res.data.data
          strategyListMore.value = ''
        }
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}
const goDetail = (detail) => {
  behaviorEvent({ event: 'click', module: 'walkthrough' }, detail)
  $router.push({
    path: '/strategy_detail',
    query: { id: detail.id, bacRoute: $route.path, bacRouteQuery: JSON.stringify($route.query || {}) }
  })
}
const goCarousel = (car) => {
  behaviorEvent({ event: 'click_banner', module: 'walkthrough' }, car || {})
  goHomeLink(car?.path, '', car)
}
const goActive = (meu) => {
  behaviorEvent(
    { event: 'click', module: 'leftnav', ext: JSON.stringify({ is_red: meu.is_red }) },
    meu
  )
  $router.push(meu.path)
}
const goWrite = () => {
  // $router.push('/article/edit_contribute')
  $router.push('/article/edit_trends')
}
const lookUpUser = (tren) => {
  const cuid =
    tren?.cuid ||
    tren?.user?.cuid
  if (!cuid) return

  $router.push({
    path: '/view_user',
    query: { cuid, bacRoute: $route.path, bacRouteQuery: JSON.stringify($route.query || {}) }
  })
}
const lookForwardsUser = (tren) => {
  $router.push({
    path: '/view_user',
    query: { cuid: tren.forwards_info.user.cuid, bacRoute: $route.path, bacRouteQuery: JSON.stringify($route.query || {}) }
  })
}
const lookRemindUser = (ante) => {
  $router.push({
    path: '/view_user',
    query: { cuid: ante.cuid, bacRoute: $route.path, bacRouteQuery: JSON.stringify($route.query || {}) }
  })
}
const trendsDetail = (trid) => {
  $router.push({
    path: '/view_trends_info',
    query: { linkid: trid.id, bacRoute: $route.path, bacRouteQuery: JSON.stringify($route.query || {}) }
  })
}
const looktopic = (talk) => {
  $router.push({ path: '/talk_trends_page', query: { topic: talk.id } })
}
const shareTrends = (tre) => {
  let reqData = {
    uname: userInfo.value.uname,
    uid: userInfo.value.uid,
    token: userInfo.value.token,
    linkid: tre.id
  }
  reqData = Object.assign(JSON.parse(localStorage.getItem('href-url')), reqData)
  shareTrendsAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        console.log('【用户分享动态接口返回】', res.data)
        showAttention.value = false
        showToast({
          type: 'success',
          message: 'Content forwarded successfully!',
          className: 'toast-success'
        })
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}
const noForward = (data) => {
  shareData.value = data
  showAttention.value = true
}
const closeNoForward = () => {
  shareData.value = ''
  showAttention.value = false
}
const confirmNoForward = () => {
  shareTrends(shareData.value)
}
const upLikeTrends = (action) => {
  console.log('【action.interact_info】', action.interact_info)

  if (isPoll.value) {
    showToast({
      type: 'fail',
      message: 'Do not operate frequently, please try again later!',
      className: 'toast-fail'
    })
    return
  }
  let reqData = {
    uname: userInfo.value.uname,
    uid: userInfo.value.uid,
    token: userInfo.value.token,
    linkid: action.id,
    action: action.interact_info?.is_like == 1 || action.is_like == 1 ? '0' : '1'
  }
  console.log('【reqData】', reqData)

  reqData = Object.assign(JSON.parse(localStorage.getItem('href-url')), reqData)
  upLikeTrendsAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        console.log('【用户点赞动态接口返回】', res.data)
        isPoll.value = true
        if (action.interact_info && action.interact_info.is_like !== undefined) {
          action.interact_info.is_like = reqData.action == '1' ? 1 : 0
          if (reqData.action == '0') {
            action.interact_info.like_count--
          } else {
            action.interact_info.like_count++
          }
        } else {
          action.is_like = reqData.action == '1' ? 1 : 0
          if (reqData.action == '0') {
            action.like--
          } else {
            action.like++
          }
        }
        timePoll()
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}
const comfirmSwitchEn = () => {
  window.location.href = transfer.value.rback
}
const timePoll = () => {
  clickPoll.value = setTimeout(() => {
    if (timeCount.value > 0) {
      timeCount.value--
      timePoll()
    } else {
      timeCount.value = 3
      isPoll.value = false
      clearTimeout(clickPoll.value)
    }
  }, 1000)
}

const goRegister = () => {
  showGiftPack.value = false
  showRegister.value = true
}
const userRegister = () => {
  userUname.value = userUname.value.replace(/\s/g, '')
  userUpwd.value = userUpwd.value.replace(/\s/g, '')
  if (!userUname.value) {
    showToast({ type: 'fail', message: 'Please enter your account!', className: 'toast-fail' })
    return
  }
  if (!userUpwd.value) {
    showToast({ type: 'fail', message: 'Please enter your password!', className: 'toast-fail' })
    return
  }
  let reqData = JSON.parse(localStorage.getItem('href-url'))
  reqData.uname = userUname.value
  reqData.upwd = userUpwd.value
  UserRegisterAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        console.log('【注册接口返回】', res.data.data)
        userStore.setUserInfo(res.data.data)
        localStorage.setItem('nsjkdjc==', encipher.des_encrypt(res.data.data))
        getUserInfo(res.data.data)
        if (window.isAndroid) {
          window.fee.afPost(
            JSON.stringify({
              af_dev: 'af_dev9527',
              cuid: 'cuid9527',
              event_type: 'register',
              text: '瞎勾八传'
            })
          )
        }
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}
const getUserInfo = (data) => {
  let reqData = {
    uname: data.uname,
    uid: data.uid,
    token: data.token
  }
  reqData = Object.assign(JSON.parse(localStorage.getItem('href-url')), reqData)
  GetUserInfoAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        userStore.setUserInfo(Object.assign(data, res.data.data))
        localStorage.setItem('nsjkdjc==', encipher.des_encrypt(Object.assign(data, res.data.data)))
        if (res.data.data.is_show_reg_gift == 1) {
          getVoucherList()
        }
        showRegister.value = false
        showToast({ type: 'success', message: res.data.msg, className: 'toast-success' })
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}
const getVoucherList = () => {
  let reqData = {
    uid: userInfo.value.uid,
    uname: userInfo.value.uname,
    token: userInfo.value.token,
    type: 'newreg'
  }
  reqData = Object.assign(reqData, JSON.parse(localStorage.getItem('href-url')))
  GetVoucherListNewUserAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        console.log('【代金券列表返回】', res.data.data)
        voucherList.value = res.data.data
        showVoucher.value = true
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}
const receiveGiftNew = () => {
  let reqData = {
    uid: userInfo.value.uid,
    uname: userInfo.value.uname,
    token: userInfo.value.token,
    gifttype: 'newreg'
  }
  reqData = Object.assign(reqData, JSON.parse(localStorage.getItem('href-url')))
  ReceiveGiftNewAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        if (window.isAndroid) {
          window.fee.openUrl(res.data.data.url)
        }
        if (window.isiOS) {
          window.webkit.messageHandlers.ios_jumpstore.postMessage(res.data.data.url)
        }
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}
const goLogin = () => {
  userStore.setShowLoginModal(true)
}
const getTime1 = (date) => {
  let differenceInMillis = Math.abs(date - new Date().getTime() / 1000)
  let h = Math.floor(differenceInMillis / 3600)
  let y = h % 24
  let s = Math.floor(h / 24)
  return 'Expires in' + s + 'days and' + y + 'hours'
}
const getTopArticles = () => {
  let reqData = {}
  if (userInfo.value) {
    reqData.uname = userInfo.value.uname
    reqData.uid = userInfo.value.uid
    reqData.token = userInfo.value.token
  }
  reqData = Object.assign(JSON.parse(localStorage.getItem('href-url') || '{}'), reqData)
  GetHomePublicListAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        topArticlesData.value = res.data.data
      } else {
        // Handle error if needed
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}

const getSpecialAnnouncements = () => {
  let reqData = {
    page: 1,
    rows: 4
  }
  if (userInfo.value) {
    reqData.uname = userInfo.value.uname
    reqData.uid = userInfo.value.uid
    reqData.token = userInfo.value.token
  }
  reqData = Object.assign(JSON.parse(localStorage.getItem('href-url') || '{}'), reqData)
  GetHomeSpecialListAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        specialAnnouncementsData.value = Array.isArray(res.data.data) ? res.data.data : []
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}

const getHomeActivityList = () => {
  let reqData = {
    page: 1,
    rows: 2
  }
  if (userInfo.value) {
    reqData.uname = userInfo.value.uname
    reqData.uid = userInfo.value.uid
    reqData.token = userInfo.value.token
  }
  reqData = Object.assign(JSON.parse(localStorage.getItem('href-url') || '{}'), reqData)
  GetHomeActivityListAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        homeActivityData.value = Array.isArray(res.data.data) ? res.data.data : []
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}

const goHomeLink = (path, module, item) => {
  if (!path) return
  if (module) {
    behaviorEvent({ event: 'click', module }, item || {})
  }
  const targetPath = String(path).trim()
  if (!targetPath) return
  if (/^https?:\/\//i.test(targetPath)) {
    window.location.href = targetPath
    return
  }
  const hasBackRoute = /(?:\?|&)bacRoute=/.test(targetPath)
  const normalizedPath = targetPath.startsWith('#') ? targetPath.slice(1) : targetPath
  const joinChar = normalizedPath.includes('?') ? '&' : '?'
  const targetWithBack = `${normalizedPath}${hasBackRoute ? '' : `${joinChar}bacRoute=/`}`

  // Keep SDK parameters and, most importantly, is_mobile=1 from the real URL.
  // Rebuilding the URL from origin alone previously dropped them and made the
  // destination render the desktop branch inside a mobile viewport.
  const currentUrl = new URL(window.location.href)
  window.location.href =
    `${currentUrl.origin}${currentUrl.pathname}${currentUrl.search}#${targetWithBack}`
}

const goSpecialAnnouncement = (item) => {
  goHomeLink(item?.path, 'special', item)
}

const goHomeActivity = (item) => {
  goHomeLink(item?.path, 'activity', item)
}

const getFeaturedPostDesc = (item) => {
  return item?.desc || item?.textxing || item?.content || '...'
}

const getFeaturedPostCover = (item) => {
  if (Array.isArray(item?.image) && item.image[0]) return item.image[0]
  if (Array.isArray(item?.pic?.ids) && item.pic.ids[0]) return item.pic.ids[0]
  return item?.coverurl || item?.cover || ''
}

const getTopTrends = () => {
  let reqData = {}
  if (userInfo.value) {
    reqData.uname = userInfo.value.uname
    reqData.uid = userInfo.value.uid
    reqData.token = userInfo.value.token
  }
  reqData = Object.assign(JSON.parse(localStorage.getItem('href-url') || '{}'), reqData)
  GetHomeTopTrendsListAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        topTrendsData.value = res.data.data?.list || []
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}

const getTChuangList = () => {
  let reqData = {
    uname: userInfo.value.uname,
    uid: userInfo.value.uid,
    token: userInfo.value.token,
    way: 'isfirst'
  }
  reqData = Object.assign(JSON.parse(localStorage.getItem('href-url')), reqData)
  GetTChuangListAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        console.log('【广告弹窗列表返回】', res.data.data)
        adList.value = res.data.data
        showDonwn.value = true
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}
const clickAD = (data) => {
  let reqData = {
    uname: userInfo.value.uname,
    uid: userInfo.value.uid,
    token: userInfo.value.token,
    propus_id: data.id,
    propus_type: '1'
  }
  reqData = Object.assign(JSON.parse(localStorage.getItem('href-url')), reqData)
  CilckADAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        console.log('【广告弹窗列表返回】', res.data.data)
        if (JSON.parse(localStorage.getItem('href-url')).wv == 1) {
          if (window.isAndroid) {
            window.fee.openAPP(data.pkg, data.className, data.url)
          }
          if (window.isiOS) {
            console.log('[ios]')
            // window.webkit.messageHandlers.ios_jumpstore.postMessage(JSON.parse(encipher.des_decrypt(localStorage.getItem('initdevice=='))).facebook);
          }
          showDonwn.value = false
        } else {
          window.location.href = data.url
        }
      } else {
        showToast({ type: 'fail', message: res.data.msg, className: 'toast-fail' })
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}

const initPoll = () => {
  initTimeOut.value = setTimeout(() => {
    if (initInfo.value) {
      getMenu()
      getBanner()
      getHomeActivityList()
      getHomeCategory()
      getTChuangList()
      getSpecialAnnouncements()
      getTopArticles()
      getTopTrends()
      // getStrategyList()
      getHotWord()
      clearTimeout(initTimeOut)
      if (!userInfo.value && initInfo.value.is_open_rnew_gift == 1) {
        showGiftPack.value = true
      }
      if (userInfo.value.is_show_reg_gift == 1) {
        getVoucherList()
      }
    } else {
      initPoll()
    }
  }, 500)
}

onMounted(() => {
  initPoll()
})
</script>
\n
<template>
  <div class="web-layout" v-if="!isMobile">
    <!-- Desktop Layout -->
    <div class="desktop-layout-wrapper">
      <DesktopHeader @login="showDesktopLogin = true" />
    </div>

    <div class="banner-wrapper-full">
      <div class="desktop-main banner-container">
        <!-- Carousel -->
        <div class="banner-section">
          <div class="banner-content">
            <ElementCarousel
              :interval="4000"
              :initial-index="0"
              autoplay
              arrow="always"
              indicator-position
              height="100%"
              style="width: 100%; height: 100%"
            >
              <ElementCarouselItem v-for="car in bannerData" :key="car.id" @click="goCarousel(car)">
                <img :src="car.coverurl" class="banner-img" />
              </ElementCarouselItem>
            </ElementCarousel>
          </div>
        </div>
      </div>
    </div>

    <div class="desktop-main">
      <!-- Event Zone -->
      <div class="event-zone">
        <div class="section-title-wrapper">
          <img src="@/assets/img/web_home/标题1@2x.png" class="section-title" />
        </div>
        <div class="event-banners">
          <img
            v-for="(item, index) in homeActivityData"
            :key="item.id || index"
            :src="item.image"
            class="event-banner-img clickable-banner"
            @click="goHomeActivity(item)"
          />
        </div>
      </div>

      <!-- Announcements Zone -->
      <div class="announcements-zone">
        <img src="@/assets/img/web_home/特别公告底框@2x.png" class="announcements-bg" />
        <div class="announcements-content">
          <div class="announcements-header-wrapper">
            <img src="@/assets/img/web_home/特别公告标题@2x.png" class="announcements-title" />
            <span class="announcements-subtitle">Don't miss any exciting content!</span>
          </div>
          <div class="announcements-list">
            <div
              class="announcement-item"
              v-for="(item, index) in specialAnnouncementsData"
              :key="item.id || index"
              role="button"
              tabindex="0"
              @click="goSpecialAnnouncement(item)"
              @keydown.enter="goSpecialAnnouncement(item)"
            >
              <img src="@/assets/img/web_home/特别公告内容条@2x.png" class="item-bg" />
              <img :src="item.icon" class="item-icon" />
              <div class="item-text">
                <div class="item-title">{{ item.title }}</div>
                <div class="item-desc">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Content Zone -->
      <div class="content-zone">
        <div class="featured-post">
          <div class="section-title-wrapper-flex">
            <div>
              <img src="@/assets/img/web_home/标题2@2x.png" class="section-title" />
            </div>
          </div>
          <div class="featured-cards">
            <div class="featured-card" v-for="(item, index) in topTrendsData.slice(0, 6)" :key="item.id || index" @click="trendsDetail(item)">
              <img src="@/assets/img/web_home/-h-精选帖子框.png" class="card-bg" />
              <div class="card-content">
                <div class="card-avatar-wrapper" role="button" tabindex="0" @click.stop="lookUpUser(item)" @keydown.enter.stop="lookUpUser(item)">
                  <img
                    v-if="item.headframe || item.user?.headframe"
                    :src="item.headframe || item.user?.headframe"
                    class="card-avatar-frame"
                  />
                  <img
                    :src="item.headimg || item.heading || item.user?.headimg || item.user?.heading || defaultAvatar"
                    class="card-avatar"
                  />
                </div>
                <div class="card-name">{{ item.user?.nick || '...' }}</div>
                <div class="card-desc" style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">
                  {{ getFeaturedPostDesc(item) }}
                </div>
                <div class="card-img-wrapper" v-if="getFeaturedPostCover(item)">
                  <img :src="getFeaturedPostCover(item)" class="card-img" style="object-fit: cover;" />
                </div>
                <div class="card-tags">
                  <span class="tag-blue" v-if="item.is_featured == 1">Featured</span>
                </div>
                <div class="card-stats">
                  <div class="stat-item">
                    <img v-if="item.interact_info?.is_like == 1 || item.is_like == 1" src="@/assets/img/like-a.png" style="width:16px;height:16px;margin-right:4px;" />
                    <img v-else src="@/assets/img/like.png" style="width:16px;height:16px;margin-right:4px;" />
                    {{ item.interact_info?.like_count || item.like || 0 }}
                  </div>
                  <div class="stat-item"><img src="@/assets/img/web_home/评论@2x.png" /> {{ item.comments_count || item.comment_num || 0 }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="top-trending">
          <div class="trending-bg-wrapper">
            <div class="trending-bg"></div>
          </div>
          <div class="trending-content">
            <div class="trending-header">
              <span class="trending-title-text">Top 10 Trending</span>
            </div>
            <img src="@/assets/img/web_home/卡咪龟立绘@2x.png" class="trending-mascot" />
            <div class="trending-list">
              <div class="trending-item" v-for="(item, index) in topArticlesData" :key="item.id || index" @click="goDetail(item)">
                <span
                  :class="['trending-rank', index < 2 ? 'rank-top' : index === 2 ? 'rank-third' : 'rank-normal']"
                  >{{ index + 1 }}</span
                >
                <span class="trending-text">{{ item.title }}</span>
                <span class="trending-count">{{ item.view > 1000 ? (item.view / 1000).toFixed(1) + 'K' : item.view }}</span>
                <div class="trending-line-css"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="floating-download" v-if="!isMobile">
     <img src="@/assets/img/web_home/-h-浮窗框.png" class="floating-bg" />
     <img src="@/assets/img/web_home/杰尼龟@2x.png" class="floating-mascot" />
     <div class="floating-content">
       <img src="@/assets/img/web_home/-h-Get Now.png" class="get-now-btn" />
       <a :href="initInfo?.appstore_down_url" target="_blank" v-if="initInfo?.appstore_down_url">
         <img src="@/assets/img/web_home/苹果下载@2x.png" class="store-btn" />
       </a>
       <img src="@/assets/img/web_home/苹果下载@2x.png" class="store-btn" v-else />
       <a :href="initInfo?.google_down_url" target="_blank" v-if="initInfo?.google_down_url">
         <img src="@/assets/img/web_home/谷歌下载@2x.png" class="store-btn" />
       </a>
       <img src="@/assets/img/web_home/谷歌下载@2x.png" class="store-btn" v-else />
     </div>
  </div>

    <div class="desktop-layout-wrapper">
      <DesktopFooter />
    </div>
  </div>
    <!-- End Desktop Layout -->

    <!-- Mobile Layout -->
    <div class="mobile-layout" v-if="isMobile">
      <MobileHeader />

      <div class="m-banner-wrapper">
        <div class="m-banner-inner">
          <!-- Top frame image which creates the border effect -->
          <img src="@/assets/img/mobile_home/顶部banner上面框.png" class="m-banner-top" />

          <!-- The actual carousel content positioned absolutely to sit "inside" the frame -->
          <div class="m-carousel-container">
            <ElementCarousel
              :interval="4000"
              :initial-index="0"
              autoplay
              arrow="always"
              indicator-position
              height="100%"
              class="m-carousel"
            >
              <ElementCarouselItem v-for="car in bannerData" :key="car.id">
                <div @click="goCarousel(car)" style="width: 100%; height: 100%; cursor: pointer; pointer-events: auto;">
                  <img :src="car.coverurl" class="m-banner-img" />
                </div>
              </ElementCarouselItem>
            </ElementCarousel>
          </div>
        </div>
      </div>

      <div class="m-main-content">
        <div class="m-event-zone">
          <div class="m-section-title-wrapper">
            <img src="@/assets/img/mobile_home/标题1.png" class="m-section-title" />
          </div>
          <div class="m-event-banners">
            <div class="m-event-banner-wrapper" v-for="(item, index) in homeActivityData" :key="item.id || index">
              <img src="@/assets/img/mobile_home/活动区banner上面框.png" class="m-event-banner-frame" />
              <img
                :src="item.image"
                class="m-event-banner-img clickable-banner"
                @click="goHomeActivity(item)"
              />
            </div>
          </div>
        </div>

        <div class="m-announcements-zone">
          <img src="@/assets/img/web_home/特别公告底框@2x.png" class="m-announcements-bg" />
          <div class="m-announcements-content">
            <div class="m-announcements-header-wrapper">
              <div class="m-ann-header-left">
                <img
                  src="@/assets/img/mobile_home/特别公告标题.png"
                  class="m-announcements-title"
                />
              </div>
            </div>
            <div class="m-announcements-list">
              <div
                class="m-announcement-item"
                v-for="(item, index) in specialAnnouncementsData"
                :key="item.id || index"
                role="button"
                tabindex="0"
                @click="goSpecialAnnouncement(item)"
                @keydown.enter="goSpecialAnnouncement(item)"
              >
                <img src="@/assets/img/web_home/特别公告内容条@2x.png" class="m-item-bg" />
                <img :src="item.icon" class="m-item-icon" />
                <div class="m-item-text">
                  <div class="m-item-title-row">
                    <span class="m-item-title">{{ item.title }}</span>
                  </div>
                  <span class="m-item-desc">{{ item.desc }}</span>
                </div>
              </div>
              <div v-if="specialAnnouncementsData.length === 0" class="m-home-empty">
                <span>Announcements are coming soon.</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Featured Post -->
        <div class="m-featured-zone">
          <div class="m-section-header">
            <div class="m-section-title-left">
              <img src="@/assets/img/web_home/标题2@2x.png" class="m-section-title-img" />
              <div class="m-sub-title">Top Content Selections!</div>
            </div>
          </div>
          <div class="m-featured-cards">
            <div class="m-featured-card" v-for="(item, index) in topTrendsData.slice(0, 6)" :key="item.id || index" @click="trendsDetail(item)">
              <img src="@/assets/img/web_home/-h-精选帖子框.png" class="m-card-bg" />
              <div class="m-card-content">
                <div class="m-card-avatar-wrapper" role="button" tabindex="0" @click.stop="lookUpUser(item)" @keydown.enter.stop="lookUpUser(item)">
                  <img
                    v-if="item.headframe || item.user?.headframe"
                    :src="item.headframe || item.user?.headframe"
                    class="m-card-avatar-frame"
                    loading="lazy"
                    decoding="async"
                  />
                  <img
                    :src="item.headimg || item.heading || item.user?.headimg || item.user?.heading || defaultAvatar"
                    class="m-card-avatar"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div class="m-card-name">{{ item.user?.nick || '...' }}</div>
                <div class="m-card-desc" style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">
                  {{ getFeaturedPostDesc(item) }}
                </div>
                <div class="m-card-img-wrapper" v-if="getFeaturedPostCover(item)">
                  <img
                    :src="getFeaturedPostCover(item)"
                    class="m-card-img"
                    style="object-fit: cover;"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div class="m-card-tags">
                  <span class="m-tag-blue" v-if="item.is_featured == 1">Featured</span>
                </div>
                <div class="m-card-stats">
                  <div class="m-stat-item">
                    <img v-if="item.interact_info?.is_like == 1 || item.is_like == 1" src="@/assets/img/like-a.png" style="width:14px;height:14px;margin-right:4px;" />
                    <img v-else src="@/assets/img/like.png" style="width:14px;height:14px;margin-right:4px;" />
                    {{ item.interact_info?.like_count || item.like || 0 }}
                  </div>
                  <div class="m-stat-item"><img src="@/assets/img/web_home/评论@2x.png" /> {{ item.comments_count || item.comment_num || 0 }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Top 10 Trending -->
        <div class="m-trending-zone">
          <img src="@/assets/img/mobile_home/卡咪龟立绘.png" class="m-trending-mascot" />
          <div class="m-trending-content">
            <div class="m-trending-header">
              <div class="m-trending-title-left">
                <div class="m-trending-blue-bar"></div>
                <span class="m-trending-title-text">Top 10 Trending</span>
              </div>
            </div>
            <div class="m-trending-list">
              <div class="m-trending-item" v-for="(item, index) in topArticlesData" :key="item.id || index" @click="goDetail(item)">
                <span :class="['m-trending-rank', index < 3 ? 'm-rank-top' : 'm-rank-normal']">{{ index + 1 }}</span>
                <span class="m-trending-text">{{ item.title }}</span>
                <span class="m-trending-count">{{ item.view > 1000 ? (item.view / 1000).toFixed(1) + 'K' : item.view }}</span>
                <img src="@/assets/img/web_home/十大热门的线@2x.png" class="m-trending-line" />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Mobile Floating Download -->
      <div class="m-floating-download" v-if="isMobile">
        <img src="@/assets/img/web_home/-h-浮窗框.png" class="m-floating-bg" />
        <img src="@/assets/img/web_home/杰尼龟@2x.png" class="m-floating-mascot" />
        <div class="m-floating-content">
          <img src="@/assets/img/web_home/-h-Get Now.png" class="m-get-now-btn" />
          <a :href="initInfo?.appstore_down_url" target="_blank" v-if="initInfo?.appstore_down_url">
            <img src="@/assets/img/web_home/苹果下载@2x.png" class="m-store-btn" />
          </a>
          <img src="@/assets/img/web_home/苹果下载@2x.png" class="m-store-btn" v-else />
          <a :href="initInfo?.google_down_url" target="_blank" v-if="initInfo?.google_down_url">
            <img src="@/assets/img/web_home/谷歌下载@2x.png" class="m-store-btn" />
          </a>
          <img src="@/assets/img/web_home/谷歌下载@2x.png" class="m-store-btn" v-else />
        </div>
      </div>
    </div>
</template>

<style scoped>
/* Mobile Styles (Default) */
.web-layout {
  background-color: #fefae1;
  width: 100%;
  font-family: sans-serif;
  position: relative;
  overflow-x: clip;
  padding-top: 60px;
}

/* Base mobile styles for components to prevent completely broken layout before desktop breakpoint */
.desktop-layout-wrapper {
  width: 100%;
}
.mobile-layout {
  width: 100%;
  background-color: #fefae1;
  background-image: url('@/assets/img/mobile_pay/bg.png');
  background-position: top center;
  background-size: 100% auto;
  background-repeat: no-repeat;
  min-height: 100vh;
  padding-top: 60px;
}

/* Mobile Specific CSS */
.mobile-header {
  height: 60px;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 101;
}

.m-header-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.m-header-content {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 15px;
}

.m-hamburger {
  width: 35px;
}
.m-logo {
  height: 40px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.m-login-btn {
  height: 30px;
  width: auto;
}

/* Mobile Menu Dropdown */
.m-menu-dropdown {
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  z-index: 100;
}
.m-menu-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1;
}
.m-menu-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0 20px;
}
.m-menu-item {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 15px 0;
  cursor: pointer;
}
.m-menu-icon {
  height: 20px;
}
.m-menu-text {
  color: #facc15;
  font-size: 16px;
  font-weight: bold;
}
.m-menu-text.is-active {
  color: #facc15; /* Same color for now, can adjust if active state differs */
}
.m-menu-divider {
  width: 90%;
  height: 2px;
  opacity: 0.5;
}

/* Mobile User Popup Overlay */
.m-user-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.m-user-popup {
  position: relative;
  width: 80%;
  max-width: 320px;
}
.m-user-popup-bg {
  width: 100%;
  display: block;
}
.m-user-popup-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 25px;
  height: 25px;
  z-index: 10;
  cursor: pointer;
}
.m-user-popup-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 25px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.m-user-popup-top {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 15px;
}
.m-user-popup-avatar-wrapper {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 2px solid #fff;
  overflow: hidden;
}
.m-user-popup-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.m-user-popup-details {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.m-user-popup-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.m-user-popup-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.m-user-popup-vip {
  height: 16px;
  width: auto;
}
.m-user-popup-uid {
  font-size: 12px;
  color: #666;
}
.m-user-popup-exp {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-top: 5px;
}
.m-exp-bar-wrapper {
  position: relative;
  width: 120px;
  height: 12px;
}
.m-exp-bar-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.m-exp-bar-inner-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  overflow: hidden;
  border-radius: 6px;
}
.m-exp-bar-inner {
  height: 100%;
  width: auto;
  min-width: 120px;
}
.m-exp-text {
  font-size: 10px;
  color: #888;
  font-weight: bold;
}
.m-user-popup-buttons {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
.m-user-popup-btn {
  height: 35px;
  cursor: pointer;
}

.m-banner-wrapper {
  width: 100%;
  position: relative;
  padding: 15px 15px 5px; /* Reduced bottom padding from 25px to 5px */
  z-index: 1;
}

.m-banner-inner {
  position: relative;
  width: 100%;
  /* Use aspect-ratio to perfectly match the frame image proportions */
  aspect-ratio: 722 / 201;
}

.m-banner-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #facc15;
  background-image: url('@/assets/img/web_home/黄色圆形@2x.png');
  background-size: 150px;
  z-index: -1;
}

.m-banner-top {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  pointer-events: none; /* Let clicks pass through to carousel */
}

.m-carousel-container {
  position: absolute;
  top: 4%; /* Using percentage to perfectly match the frame inner edge across all mobile sizes */
  left: 1.1%; /* Match the frame's left inner edge */
  width: 97.8%; /* Fill the width within the frame borders */
  height: 92%; /* Fit exactly inside the frame proportionally */
  z-index: 1;
  border-radius: 10px;
  overflow: hidden;
}

.m-carousel {
  width: 100%;
  height: 100%;
  /* Removed manual borders since the image frame provides them */
}
.m-banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Mobile Carousel Custom Arrows */
.m-carousel-container :deep(.el-carousel__arrow) {
  background-color: transparent !important;
  width: 44px;
  height: 44px;
  background-size: 30px 30px !important;
  margin-top: -10px; /* Adjust arrow position slightly up due to new indicator bar */
}
.m-carousel-container :deep(.el-carousel__arrow i) {
  display: none;
}
.m-carousel-container :deep(.el-carousel__arrow--left) {
  background-image: url('@/assets/img/mobile_home/向左.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  left: 5px;
}
.m-carousel-container :deep(.el-carousel__arrow--right) {
  background-image: url('@/assets/img/mobile_home/向右.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  right: 5px;
}

/* Mobile Carousel Indicators */
.m-carousel-container :deep(.el-carousel__indicators--horizontal) {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: auto;
  min-width: 120px;
  padding: 0 20px;
  height: 20px;
  background-image: url('@/assets/img/mobile_home/顶部栏色块.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.m-carousel-container :deep(.el-carousel__indicator--horizontal) {
  width: 28px;
  height: 28px;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.m-carousel-container :deep(.el-carousel__indicator--horizontal .el-carousel__button) {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-image: url('@/assets/img/mobile_home/椭圆 2 拷贝.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  opacity: 1;
}
.m-carousel-container :deep(.el-carousel__indicator--horizontal.is-active .el-carousel__button) {
  background-image: url('@/assets/img/mobile_home/椭圆 2.png');
}

.m-home-empty {
  min-height: 92px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  font-weight: 700;
  text-align: center;
}

.m-main-content {
  padding: 5px 15px 80px; /* Reduced top padding from 15px to 5px to close the gap */
  display: flex;
  flex-direction: column;
  gap: 15px; /* Reduced overall gap between main sections slightly */
}

.m-section-title-wrapper {
  margin-bottom: 10px;
}
.m-section-title {
  height: 30px;
}

.m-event-banners {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.m-event-banner-wrapper {
  position: relative;
  width: 100%;
}
.m-event-banner-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;
}
.m-event-banner-img {
  width: 100%;
  border-radius: 10px;
  display: block;
}

.m-announcements-zone {
  position: relative;
  min-height: 305px;
}
.m-announcements-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
}
.m-announcements-content {
  position: relative;
  z-index: 1;
  padding: 13px 18px 16px;
}
.m-announcements-header-wrapper {
  margin-bottom: 10px;
}
.m-announcements-title {
  width: auto;
  height: 36px;
  object-fit: contain;
}
.m-announcements-subtitle {
  margin-top: -4px;
  margin-left: 50px;
  color: #dcecff;
  font-size: 11px;
  line-height: 1.2;
  display: block;
}

.m-announcements-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.m-announcement-item {
  position: relative;
  height: 51px;
  display: flex;
  align-items: center;
  padding: 0 11px;
  border-radius: 11px;
  overflow: hidden;
}
.m-item-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.m-item-icon {
  width: 39px;
  height: 39px;
  flex: 0 0 39px;
  margin-right: 9px;
  object-fit: contain;
}
.m-item-text {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
}

.m-item-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.m-item-title {
  font-weight: bold;
  font-size: 15px;
  line-height: 1.15;
  color: #ffffff;
  text-shadow: 0 1px 1px rgba(0, 48, 100, 0.25);
}
.m-item-time {
  color: #315e8e;
  font-size: 9px;
}
.m-item-desc {
  width: 100%;
  max-width: none;
  color: #eaf3ff;
  font-size: 10.5px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Featured Post Mobile */
.m-featured-zone {
  margin-top: 10px;
}
.m-section-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 15px;
  padding: 0 5px;
}
.m-section-title-img {
  height: 24px;
  margin-bottom: 4px;
}
.m-sub-title {
  font-size: 10px;
  color: #666;
}
.m-more-btn {
  font-size: 12px;
  color: #3b82f6;
  cursor: pointer;
}

.m-featured-cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    padding-top: 25px;
  }
.m-featured-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
  cursor: pointer;
}
.m-card-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  border-radius: 10px;
}
.m-card-content {
  position: relative;
  z-index: 1;
  padding: 35px 10px 15px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.m-card-avatar-wrapper {
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 50px;
}
.m-card-avatar-frame {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
}
.m-card-avatar {
  position: absolute;
  width: 85%;
  height: 85%;
  top: 7.5%;
  left: 7.5%;
  border-radius: 50%;
  z-index: 1;
}
.m-card-name {
  font-weight: bold;
  color: #1e3a8a;
  font-size: 13px;
  margin-bottom: 5px;
  text-align: center;
}
.m-card-desc {
  font-size: 10px;
  color: #666;
  word-break: break-word;
  text-align: center;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.m-card-img-wrapper {
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: 6px;
  margin-bottom: 10px;
}
.m-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.m-card-tags {
  display: flex;
  gap: 5px;
  margin-bottom: 10px;
  width: 100%;
  justify-content: flex-start;
}
.m-tag-blue {
  color: #3b82f6;
  border: 1px solid #3b82f6;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 9px;
}
.m-tag-pink {
  color: #ec4899;
  border: 1px solid #ec4899;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 9px;
}
.m-card-stats {
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  width: 100%;
  border-top: 1px solid #eee;
  padding-top: 10px;
}
.m-stat-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #666;
}
.m-stat-item img {
  width: 14px;
}

/* Top 10 Trending Mobile */
.m-trending-zone {
  position: relative;
  margin-top: 20px;
  padding-top: 20px;
}
.m-trending-mascot {
  position: absolute;
  top: -15px;
  right: 0px;
  width: 70px;
  z-index: 3;
}
.m-trending-content {
  position: relative;
  z-index: 1;
  border-radius: 15px;
  overflow: hidden;
  border: 2px solid #1e3a8a;
  background: #fff;
}
.m-trending-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background-color: #facc15;
  border-bottom: 2px solid #1e3a8a;
}
.m-trending-title-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.m-trending-blue-bar {
  width: 4px;
  height: 16px;
  background-color: #fff;
  border-radius: 2px;
}
.m-trending-title-text {
  font-size: 16px;
  font-weight: 900;
  color: #1e3a8a;
  font-style: italic;
}
.m-explore-more-btn {
  font-size: 10px;
  color: #1e3a8a;
  font-weight: bold;
  cursor: pointer;
}

.m-trending-list {
  padding: 0 15px 10px;
  background: #fff;
}
.m-trending-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  position: relative;
}
.m-trending-rank {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  margin-right: 12px;
}
.m-rank-top {
  background-color: #ef4444;
  color: white;
}
.m-rank-normal {
  background-color: #facc15;
  color: white;
}
.m-trending-text {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.m-trending-count {
  flex: 0 0 auto;
  min-width: 34px;
  margin-left: auto;
  text-align: right;
  font-size: 11px;
  color: #9ca3af;
}
.m-trending-line {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
}

/* Mobile Floating Download */
.m-floating-download {
  position: fixed;
  right: 0;
  top: 60%;
  transform: translateY(-50%);
  width: 28vw;
  max-width: 110px;
  min-width: 90px;
  z-index: 98;
}
.m-floating-bg {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}
.m-floating-mascot {
  position: absolute;
  top: -40%;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  z-index: 2;
}
.m-floating-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12% 5% 10%;
  gap: 5px;
}
.m-get-now-btn {
  width: 90%;
  margin-top: 5%;
}
.m-store-btn {
  width: 90%;
  cursor: pointer;
}

/* Desktop Styles */
@media screen and (min-width: 920px) {
  .web-layout {
    background-image: url('@/assets/img/web_home/元素 拷贝.png');
    background-repeat: repeat;
    background-size: auto;
    background-attachment: scroll;
    padding-top: 100px;
  }
  .desktop-layout-wrapper {
    width: 100%;
  }

  .desktop-main {
    display: flex;
    width: 75%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 40px 0 100px; /* Added 40px top padding */
    flex-direction: column;
    gap: 40px; /* Increased gap between sections for better breathing room */
  }

  .banner-wrapper-full {
    display: block;
    width: 100%;
    background-color: rgba(250, 204, 21, 0.6); /* Transparent yellow to see the background */
    padding: 30px 0 0 0;
    border-bottom: 2px solid #eab308;
    margin-bottom: 30px;
    /* Removed fixed height so it flows with content */
  }

  .floating-download {
    display: block;
    position: fixed;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    width: 10vw; /* Use viewport width for responsive scaling */
    min-width: 120px; /* Minimum size */
    max-width: 180px; /* Maximum size */
    z-index: 100;
  }

  .web-layout {
    display: flex;
    flex-direction: column;
    padding-top: 100px;
  }

  .desktop-layout-wrapper:last-child {
    margin-top: auto;
  }
  .banner-container {
    padding: 0 !important;
    margin-bottom: -40px !important; /* Pull the content up to create the overlap */
    transform: translateY(0);
  }

  .banner-section {
    width: 100%;
    position: relative;
    /* Use aspect-ratio to perfectly match the image proportions (approx 3.8:1) */
    aspect-ratio: 1200 / 315;
    height: auto;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    border: 7px solid #3b82f6;
  }

  .banner-content {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;
    cursor: pointer;
  }

  .banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }

  .banner-content :deep(.el-carousel__item),
  .banner-content :deep(.el-carousel__arrow),
  .banner-content :deep(.el-carousel__indicator),
  .banner-content :deep(.el-carousel__button) {
    cursor: pointer;
  }

  .event-zone {
    width: 100%;
  }

  .section-title {
    height: 40px;
    width: auto;
  }

  .section-title-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 15px;
  }
  .section-subtitle {
    color: #555;
    font-size: 14px;
    margin-top: 5px;
  }

  .event-banners {
    display: flex;
    gap: 20px;
    justify-content: space-between;
  }

  .event-banner-img {
    width: calc(50% - 10px);
    height: auto;
    border-radius: 20px;
    display: block;
  }

  .clickable-banner {
    cursor: pointer;
  }

  .announcements-zone {
    position: relative;
    width: 100%;
    height: auto;
    min-height: 300px;
  }

  .announcements-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  .announcements-content {
    position: relative;
    z-index: 1;
    padding: 30px 40px;
  }

  .announcements-title {
    height: 40px;
    width: auto;
  }

  .announcements-header-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 15px;
  }
  .announcements-subtitle {
    color: #eee;
    font-size: 12px;
    margin-top: 5px;
  }

  .announcements-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .announcement-item {
    position: relative;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    cursor: pointer;
  }

  .announcement-item:focus-visible {
    outline: 3px solid #ffcc00;
    outline-offset: 2px;
    border-radius: 12px;
  }

  .item-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  .item-icon {
    width: 40px;
    height: 40px;
    margin-right: 20px;
  }

  .item-text {
    display: flex;
    flex-direction: column;
    color: #fff;
  }

  .item-title {
    font-weight: bold;
    font-size: 16px;
  }

  .item-desc {
    font-size: 12px;
    opacity: 0.8;
  }

  .item-time {
    font-size: 12px;
    color: #ccc;
    margin-left: auto;
  }

  .content-zone {
    display: flex;
    gap: 30px;
    align-items: flex-end; /* Align all items to the bottom */
  }

  .featured-post {
    flex: 1;
  }

  .section-title-wrapper-flex {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 15px;
    width: 100%;
  }

  .more-btn {
    color: #4da6ff;
    font-size: 14px;
    cursor: pointer;
  }

  .featured-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 40px; /* Added margin to separate cards from the title */
  }

  .featured-card {
    position: relative;
    flex: 1;
    min-width: 0; /* Prevent flex blowout from long unbroken text */
    /* Removed fixed height so it adapts to image */
    cursor: pointer;
  }

  .card-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  .card-content {
    position: relative;
    z-index: 1;
    padding: 30px 20px 20px; /* Increased top padding for avatar overlap */
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .card-avatar-wrapper {
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 80px;
  }

  .card-avatar-frame {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }

  .card-avatar {
    position: absolute;
    top: 6px;
    left: 6px;
    width: 68px;
    height: 68px;
    border-radius: 50%;
    z-index: 1;
  }

  .card-name {
    font-weight: bold;
    color: #1e5bb8;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .card-desc {
    font-size: 12px;
    color: #666;
    margin-bottom: 12px;
    word-break: break-word; /* Ensure long continuous text wraps */
    min-height: 36px;
    width: 100%;
  }

  .card-img-wrapper {
    width: 100%;
    aspect-ratio: 16 / 9;
    overflow: hidden;
    border-radius: 8px;
    margin-bottom: 12px;
  }

  .card-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .card-tags {
    display: flex;
    gap: 10px;
    margin-top: 15px;
    width: 100%;
  }

  .tag-blue {
    border: 1px solid #4da6ff;
    color: #4da6ff;
    border-radius: 10px;
    padding: 2px 8px;
    font-size: 12px;
  }

  .tag-pink {
    border: 1px solid #ff4da6;
    color: #ff4da6;
    border-radius: 10px;
    padding: 2px 8px;
    font-size: 12px;
  }

  .card-stats {
    display: flex;
    justify-content: flex-start;
    gap: 15px;
    margin-top: 15px;
    border-top: 1px solid #eee;
    padding-top: 15px;
    width: 100%;
  }

  .stat-item {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #666;
  }

  .stat-item img {
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }

  .top-trending {
    width: 300px;
    position: relative;
  }

  .trending-bg-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  .trending-bg {
    width: 100%;
    height: 100%;
    background: #ffffff;
    border: 3px solid #204d8d;
    border-radius: 14px;
    box-sizing: border-box;
  }

  .trending-content {
    position: relative;
    z-index: 1;
    padding: 0;
  }

  .trending-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #facc15;
    padding: 15px 20px;
    border-radius: 13px 13px 0 0;
    margin-bottom: 10px;
    position: relative;
  }

  .trending-header::before {
    content: '';
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 18px;
    background-color: #fff;
    border-radius: 2px;
  }

  .trending-title-text {
    font-weight: 900;
    color: #1e3a8a;
    font-size: 18px;
    margin-left: 5px;
  }

  .explore-more-btn {
    font-size: 12px;
    color: #1e3a8a;
    cursor: pointer;
    white-space: nowrap;
    font-weight: bold;
    margin-right: 50px;
  }

  .trending-mascot {
    position: absolute;
    top: -40px;
    right: -20px;
    width: 80px;
    z-index: 2;
  }

  .trending-list {
    display: flex;
    flex-direction: column;
    padding: 0 20px 20px;
  }

  .trending-item {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 12px 0;
    position: relative;
  }

  .trending-line-css {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #facc15;
    opacity: 0.5;
  }

  .trending-rank {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    margin-right: 10px;
    color: white;
  }

  .rank-top {
    background-color: #ef4444;
  }

  .rank-third {
    background-color: #3b82f6;
  }

  .rank-normal {
    background-color: #facc15;
    color: #1e3a8a;
  }

  .trending-text {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    color: #1e3a8a;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .trending-count {
    flex: 0 0 auto;
    min-width: 42px;
    margin-left: auto;
    text-align: right;
    font-size: 12px;
    color: #94a3b8;
  }

  .floating-bg {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }

  .floating-mascot {
    position: absolute;
    top: -40%; /* Relative positioning */
    left: 50%;
    transform: translateX(-50%);
    width: 70%; /* Relative width */
    z-index: 2;
  }

  .floating-content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 10px;
    gap: 10px;
  }

  .get-now-btn {
    width: 100%;
    margin-top: 10px;
  }

  .store-btn {
    width: 90%;
    cursor: pointer;
  }

  .footer-content {
    display: flex;
    align-items: center;
    gap: 20px;
    max-width: 1200px;
    width: 100%;
    padding: 0 20px;
  }

  .pegi-icon {
    width: 60px;
    height: auto;
  }

  .footer-text {
    color: #fff;
    font-size: 12px;
    line-height: 1.6;
  }
  .footer-text p {
    margin: 0;
  }

  /* Carousel Custom Arrows */
  .banner-content :deep(.el-carousel__arrow) {
    background-color: transparent !important;
    width: 40px;
    height: 40px;
  }
  .banner-content :deep(.el-carousel__arrow i) {
    display: none;
  }
  .banner-content :deep(.el-carousel__arrow--left) {
    background-image: url('@/assets/img/web_home/向左.png');
    background-size: contain;
    background-repeat: no-repeat;
  }
  .banner-content :deep(.el-carousel__arrow--right) {
    background-image: url('@/assets/img/web_home/向右.png');
    background-size: contain;
    background-repeat: no-repeat;
  }

  /* Carousel Indicators */
  .banner-content :deep(.el-carousel__indicators--horizontal) {
    background: rgba(0, 0, 100, 0.5);
    border-radius: 10px;
    padding: 2px 10px;
    bottom: 10px;
  }
  .banner-content :deep(.el-carousel__indicator--horizontal .el-carousel__button) {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #fff;
    opacity: 0.5;
  }
  .banner-content :deep(.el-carousel__indicator--horizontal.is-active .el-carousel__button) {
    background-color: #facc15;
    opacity: 1;
  }
}
</style>
